import React, { useMemo } from "react";
import KC_Heading3 from "../../designsystem/typography/KC-Heading/KC_Heading3";
import NiceModal from "@ebay/nice-modal-react";
import POSASelectorModal from "../modal/POSASelectorModal/POSASelectorModal";
import { POSAMode } from "../../app/19_JetpackConfig/components/POSAEditor/model";
import {
  POSA_FORMAT,
  POSATypeJavascriptDTO
} from "@tootsweet/model/lottery/POSAType";
import KC_Button from "../../designsystem/KC_Button/KC_Button";
import { tt } from "../../utils/i18n/i18n";
import { getWidthForPOSAFormat, getHeightForPOSAFormat } from "kadow-svg-utils";
import { POSA_FORMAT_ARRAY } from "../../app/19_JetpackConfig/components/POSDisplay/constants";

interface Props {
  format: POSA_FORMAT;
  posaMode: POSAMode;
  imgURL: string;
  cover?: boolean;
  hideTitle?: boolean;
  posaList?: POSATypeJavascriptDTO[];
}

export default function POSAPlaceholder(props: Props) {
  const openPOSASelectorModal = () => {
    void NiceModal.show(POSASelectorModal, {
      format: props.format,
      posaMode: props.posaMode,
      posaList: props.posaList
    });
  };

  const DIM = useMemo(() => {
    return {
      width: getWidthForPOSAFormat(props.format)
    };
  }, [props.format]);

  return (
    <div
      id={`posa-place-holder-${props.format}`}
      className="d-flex flex-column gap-sm cursor-pointer posa-placeholder"
      style={{
        width: DIM.width
      }}
      onClick={openPOSASelectorModal}
    >
      {props.hideTitle ? (
        <div style={{ height: 24 }} />
      ) : (
        <KC_Heading3
          text={POSA_FORMAT_ARRAY[props.format]}
          style={{ minHeight: 24 }}
        />
      )}

      <img
        src={props.imgURL}
        height={getHeightForPOSAFormat(props.format)}
        style={{
          objectFit: props.cover ? "cover" : undefined
        }}
        className="placeholder-image"
      />
      <KC_Button
        id={`choose-model-${props.format}`}
        text={tt("choose_a_model")}
      />
    </div>
  );
}
